import { i18n } from "@/i18n/config"

/**游戏类型 */
const gameTypes = [
    {
        name: "TODO",
        value: 0,
    },
    {
        name: "777",
        value: 1,
    },
    {
        name: "PG",
        value: 2,
    },
    {
        name: "PP",
        value: 3,
    },
    {
        name: "JILI",
        value: 4,
    },
    {
        name: "TADA",
        value: 5,
    }
];
/**轮播图 */
const banners = [
    {
        id: "1",
        url: require('@/assets/images/activitys/' + i18n.global.t('banner.img.1')),
        link: "/cashBack",
    },
    {
        id: "2",
        url: require('@/assets/images/activitys/' + i18n.global.t('banner.img.2')),
        link: "/vip",
    },
    {
        id: "3",
        url: require('@/assets/images/activitys/' + i18n.global.t('banner.img.3')),
        link: "/share",
    },
    {
        id: "4",
        url: require('@/assets/images/activitys/' + i18n.global.t('banner.img.4')),
        link: "/agent",
    },
    {
        id: "5",
        url: require('@/assets/images/activitys/' + i18n.global.t('banner.img.5')),
        link: "/betBack",
    },
    {
        id: "6",
        url: require('@/assets/images/activitys/' + i18n.global.t('banner.img.6')),
        link: "/lossBack",
    },
    {
        id: "7",
        url: require('@/assets/images/activitys/' + i18n.global.t('banner.img.7')),
        link: "/wdTask",
    }
];
/**底部列表 */
const navbarList = [
    {
        name: "home",
        icon: require("@/assets/images/home/navbar_icon1.png"),
        iconActive: require("@/assets/images/home/navbar_icon1_active.png"),
        text: i18n.global.t("home.26"),
        path: "/",
    },
    {
        name: "activity",
        icon: require("@/assets/images/home/navbar_icon2.png"),
        iconActive: require("@/assets/images/home/navbar_icon2_active.png"),
        text: i18n.global.t("home.1"),
        path: "/activitys",
    },
    {
        name: "withdraw",
        icon: require("@/assets/images/home/navbar_icon3.png"),
        iconActive: require("@/assets/images/home/navbar_icon3_active.png"),
        text: i18n.global.t("home.27"),
        path: "/withdraw",
    },
    {
        name: "invite",
        icon: require("@/assets/images/home/navbar_icon4.png"),
        iconActive: require("@/assets/images/home/navbar_icon4_active.png"),
        text: i18n.global.t("home.28"),
        path: "/agent",
    },
    {
        name: "info",
        icon: require("@/assets/images/home/navbar_icon5.png"),
        iconActive: require("@/assets/images/home/navbar_icon5_active.png"),
        text: i18n.global.t("home.29"),
        path: "/userInfo",
    }
];

/**游戏类型图标 */
const gameTypsIcons = [
    require("@/assets/images/bottom/PGD.png"),
    require("@/assets/images/bottom/PPD.png"),
    require("@/assets/images/bottom/TADA.png"),
    require("@/assets/images/bottom/jili.png"),
];
export {
    gameTypes,
    banners,
    navbarList,
    gameTypsIcons
}